






























import Vue from 'vue'
export default Vue.extend({
    data: () => ({
        logoImage: require("@/assets/JUZZAPLOGO.png"),
    })
})
